import React from 'react';
import {SelectField, SelectInput} from "react-admin";

const choices = [
    {id: 'RUBRIC_TYPE_CAMPAIGN', name: 'Rubrique de campagnes'},
    {id: 'RUBRIC_TYPE_CHALLENGE', name: 'Rubrique de défis'},
    {id: 'RUBRIC_TYPE_PAGE', name: 'Rubrique de pages'},
];

const SelectRubricTypeInput = (props) => (
    <SelectInput {...props} choices={choices}/>
);

const SelectRubricTypeField = (props) => (
    <SelectField {...props} choices={choices}/>
);

export {SelectRubricTypeInput, SelectRubricTypeField};
